import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { CategoriaIndicador, Indicador } from '@app/shared';

@Injectable()
export class IndicatorsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta de todas las categorias de indicadores
   *
   * @returns {Observable<CategoriaIndicador[]>}
   * @memberof IndicatorsDataService
   */
  getCategoryIndicator(): Observable<CategoriaIndicador[]> {
    return new Observable(obs => {
      this.http.get<CategoriaIndicador[]>(this.api.get('indicatorsSearchs')).subscribe(
        categorys => {
          if (categorys && categorys.length) {
            categorys.sort((a, b) => a.id - b.id);
          }
          obs.next(categorys);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta de los indicadores por categoria
   *
   * @param {number} idCategory
   * @returns {Observable<Indicador[]>}
   * @memberof IndicatorsDataService
   */
  getIndicatorsCategory(idCategory: number): Observable<Indicador[]> {
    return new Observable(obs => {
      this.http.get<Indicador[]>(this.api.get('indicatorsSearchs', [idCategory])).subscribe(
        indicators => {
          obs.next(indicators);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/indicators/shared/indicators-data.service.ts